const types = {
    ADD_PACKAGE: 'ADD_PACKAGE',
    REMOVE_PACKAGE: 'REMOVE_PACKAGE',
    GET_DINARDAP_IDENTIFICACION: 'GET_DINARDAP_IDENTIFICACION',
    GET_DINARDAP_APELLIDOS_NOMBRES: 'GET_DINARDAP_APELLIDOS_NOMBRES',
    GET_DINARDAP_PLACA_MOTOR_CHASIS: 'GET_DINARDAP_PLACA_MOTOR_CHASIS',
    GET_DINARDAP_RUC: 'GET_DINARDAP_RUC',
    GET_DINARDAP_RAZON_SOCIAL: 'GET_DINARDAP_RAZON_SOCIAL',
    GET_DINARDAP_IDENTIFICACION_NACIONALIDAD: 'GET_DINARDAP_IDENTIFICACION_NACIONALIDAD',
    GET_DINARDAP_IDENTIFICACION_ANIO: 'GET_DINARDAP_IDENTIFICACION_ANIO',
    GET_DINARDAP_DOCIMPORTADOR_NUMAUTORIZACION: 'GET_DINARDAP_DOCIMPORTADOR_NUMAUTORIZACION',
    GET_ALL_VARIABLES: 'GET_ALL_VARIABLES',
    STORE_RESULTS: 'STORE_RESULTS',
    STORE_VARIABLES: 'STORE_VARIABLES',
    REMOVE_PACKAGE_RESULTS: 'REMOVE_PACKAGE_RESULTS',
    REMOVE_RESULTS: 'REMOVE_RESULTS',
    ERROR_RESULT: 'ERROR_RESULT'
}

export default types;

export const addPackage = (tipoBusqueda, paquete) => {
    return { type: types.ADD_PACKAGE, payload: { tipoBusqueda, paquete } };
}

export const removePackage = (paquete) => {
    return { type: types.REMOVE_PACKAGE, payload: { paquete } };
}

export const removePackageResults = () => {
    return { type: types.REMOVE_PACKAGE_RESULTS };
}

export const getDinardapByIdentificacion = (identificacion, paquetes) => {
    return { type: types.GET_DINARDAP_IDENTIFICACION, payload: { identificacion, paquetes } };
}

export const getDinardapByNombresApellidos = (apellido1, apellido2, nombre1, nombre2, paquetes) => {
    return { type: types.GET_DINARDAP_APELLIDOS_NOMBRES, payload: { apellido1, apellido2, nombre1, nombre2, paquetes } };
}

export const getDinardapByPlacaMotorChasis = (tipoConsultaVehiculo, identificacionVehiculo, paquetes) => {
    return { type: types.GET_DINARDAP_PLACA_MOTOR_CHASIS, payload: { tipoConsultaVehiculo, identificacionVehiculo, paquetes } };
}

export const getDinardapByRuc = (ruc, paquetes) => {
    return { type: types.GET_DINARDAP_RUC, payload: { ruc, paquetes } };
}

export const getDinardapByRazonSocial = (razonSocial, paquetes) => {
    return { type: types.GET_DINARDAP_RAZON_SOCIAL, payload: { razonSocial, paquetes } };
}

export const getDinardapByIdentificacionNacionalidad = (identificacion, nacionalidad, paquetes) => {
    return { type: types.GET_DINARDAP_IDENTIFICACION_NACIONALIDAD, payload: { identificacion, nacionalidad, paquetes } };
}

export const getDinardapByIdentificacionAnio = (identificacion, anio, paquetes) => {
    return { type: types.GET_DINARDAP_IDENTIFICACION_ANIO, payload: { identificacion, anio, paquetes } };
}

export const getDinardapByDocImportadorNumAutorizacion = (numDocImportador, numAutorizacion, paquetes) => {
    return { type: types.GET_DINARDAP_DOCIMPORTADOR_NUMAUTORIZACION, payload: { numDocImportador, numAutorizacion, paquetes } };
}

export const storeResults = (results) => {
    return { type: types.STORE_RESULTS, payload: results };
}

export const removeResult = () => {
    return { type: types.REMOVE_RESULTS }
}

export const getAllVariables = () => {
    return { type: types.GET_ALL_VARIABLES };
}

export const storeVariables = (results) => {
    return { type: types.STORE_VARIABLES, payload: results };
}

export const errorResult = () => {
    return { type: types.ERROR_RESULT }
}